import React, { Component } from "react"
import PropTypes from 'prop-types'

import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Redux
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"


// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation"

//import { loginUserAction } from '../../actions/authenticationActions';
import { apiError, loginUser } from "../../store/actions"

import loginImg from "../../assets/img/agent-login.png"

const FooterLogin = React.lazy(() => import("components/VerticalLayout/Footerlogin"))

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showPassword: false,
    }

    // handleValidSubmit
    this.handleValidSubmit = this.handleValidSubmit.bind(this)
  }
   togglePassword = () => {
    this.setState((prev) => ({ showPassword: !prev.showPassword }));
  };
  // handleValidSubmit
  handleValidSubmit(event, values) {
    this.props.loginUser(values, this.props.history)
    console.log(values);
  }

  componentDidMount() {
    this.clearLoginError()
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.location?.pathname !== this.props.location?.pathname &&
      this.props.location?.pathname === "/login"
    ) {
      this.clearLoginError()
    }
  }

  clearLoginError = () => {
    this.props.apiError("")
  }

  getErrorMessage = error => {
    if (!error) return ""
    if (typeof error === "string") return error
    const apiMessage =
      error?.response?.data?.message ||
      error?.response?.data?.Message
    if (apiMessage) return apiMessage
    if (error?.message?.includes("status code")) {
      return "Invalid User"
    }
    return error?.message || "Something went wrong"
  }


  render() {
     const { showPassword } = this.state;
     const errorMessage = this.getErrorMessage(this.props.error);
    return (
      <React.Fragment>
         <ToastContainer autoClose={2000} />
        
         <div className="account-pages">
          <Container>
            <Row className="justify-content-center align-items-center vh-100">
              <Col md={10}>
                <div className="overflow-hidden my-5">
                 
                  <CardBody className="pt-4">
                    <Row>
                      <Col lg={4}>
                      <div className="login-heading">
                    <h1>Client Login</h1>
                        </div>
                        <div className="p-2">
                        <AvForm
                            className="form-horizontal"
                            method="post"
                            onValidSubmit={this.handleValidSubmit}
                          >
                            {errorMessage ? (
                              <Alert color="danger">{errorMessage}</Alert>
                            ) : null}
                            <div className="mb-3">
                              <AvField
                                name="email"
                                label="Client Id"
                                value=""
                                className="form-control"
                                placeholder="Client Id"
                                type="text"
                                required
                              />
                            </div>

                            <div className="mb-3 position-relative">
                                <AvField
                                  name="password"
                                  label="Password"
                                  placeholder="Enter Password"
                                  type={showPassword ? "text" : "password"}
                                  required
                                />
                                <span
                                  onClick={this.togglePassword}
                                  style={{
                                    position: "absolute",
                                    top: "38px", // adjust to align with input
                                    right: "10px",
                                    cursor: "pointer",
                                    color: "#666",
                                  }}
                                >
                                  {showPassword ? <i className="far fa-eye" /> :  <i className="far fa-eye-slash" />}
                                </span>
                                </div>

                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="customControlInline"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="customControlInline"
                              >
                                Remember me
                              </label>
                            </div>

                            <div className="mt-3 d-grid">
                              <button
                                className="btn btn-login"
                                type="submit"
                              >
                               Submit
                              </button>
                            </div>

                            <div className="mt-4 text-center">
                              <Link to="/forgot-password" className="text-muted">
                                <i className="mdi mdi-lock me-1" /> Forgot your
                                password?
                              </Link>
                            </div>
                          </AvForm>
                        </div>
                      </Col>
                      <Col lg={2}></Col>
                      <Col md={6} lg={6} xl={5}>
                      <img src={loginImg} className="img-fluid" alt="Client login" loading="lazy" decoding="async" />
                    </Col>
                    </Row>
                  
                  </CardBody>
                </div>
                
              </Col>
             
            </Row>
          </Container>
          <React.Suspense fallback={null}>
            <FooterLogin />
          </React.Suspense>
        </div>
      </React.Fragment>
    )
  }
}

Login.propTypes = {
  apiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  location: PropTypes.object,
  loginUser: PropTypes.func,
}

const mapStateToProps = state => {
  const { error } = state.Login
  return { error }
}

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError })(Login)
)
